module.exports = __webpack_public_path__ + "img/beautiful.bc7ab14.png";